import {Component, Input} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-card-technical-error',
  templateUrl: './card-technical-error.component.html',
  styleUrls: []
})
export class CardTechnicalErrorComponent {
  @Input() id = '';
  @Input() errorResponse: HttpErrorResponse = null;

  isServerError() {
    return this.errorResponse?.status === 500;
  }
}
